import { render, staticRenderFns } from "./VrstaPrometaDetails.vue?vue&type=template&id=d877778c&scoped=true&"
import script from "./VrstaPrometaDetails.vue?vue&type=script&lang=js&"
export * from "./VrstaPrometaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d877778c",
  null
  
)

export default component.exports